/* React hooks */
import {useEffect, useState} from "react";
/* Routing */
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
/* Contexts */
import useData from "../../../hooks/useData";
/* Components */
import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import {getAgencyUserList} from "../../../api/admin/userReq";
import useAuth from "../../../hooks/useAuth";
import {
    getAgencyBillingInfos, getAgencyContactInfos, getAgencyContactProInfos,
    getAgencyMainInfos, getAgencyRelationInfos,
    getAgencySiteInfos, getBillingAgencyList
} from "../../../api/admin/agencyReq";
import {getEnsembleList} from "../../../api/admin/ensembleReq";
import FormAgencyGeneral from "../../../forms/admin/agency/FormAgencyGeneral";
import FormAgencyCreate from "../../../forms/admin/agency/FormAgencyCreate";
import FormAgencyContacts from "../../../forms/admin/agency/FormAgencyContacts";
import FormAgencyRelation from "../../../forms/admin/agency/FormAgencyRelation";
import FormAgencySis from "../../../forms/admin/agency/FormAgencySis";
import Dashboard from "../../../components/common/dashboard/Dashboard";
import {agencyUsersOrder} from "../../../helper/orders";
import ViewAgencyBilling from "./ViewAgencyBilling";
import Missing from "../../Missing";
import TiptapView from "../../../components/common/input-layout/tiptap/TiptapView";
import {getCountryList} from "../../../api/admin/addressReq";
import {filterCountryList} from "../../../helper/tools";
import {getNetworkList} from "../../../api/pro/networkReq";
import {safeJwtDecode} from "../../../helper/jwtHelper";
import {newLoginOefApiRecord} from "../../../api/admin/oefApiRecord";

export default function ViewAgenciesInfos({ tab }) {
    const imageBaseUrl = process.env.REACT_APP_LOCAL_ASSETS_BASE_URL;
    const { id } = useParams();
    const {
        agencyUserList, setAgencyUserList,
        agencySite, setAgencySite,
        agencyMainInfos, setAgencyMainInfos,
        agencyContact, setAgencyContact,
        agencyBilling, setAgencyBilling,
        setNetworkList,
        setEnsembleList,
        setBillingAgencyList,
        agencyRelation, setAgencyRelation,
        countryList, setCountryList
    } = useData();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [ apiPassword, setApiPassword ] = useState("");
    const [ newPassword, setNewPassword ] = useState(false);

    const apiCountryList = async () => {
        const response = await getCountryList(token)
        setCountryList(response)
    }

    const selectedCountry = filterCountryList(countryList, agencyContact?.address?.country);

    const { auth } = useAuth();
    const token = auth.token;
    const decodedToken = safeJwtDecode(token);
    const agencyProId = decodedToken?.agency;
    const tabSource = "fa fa-bars";

    const [ showModal, setShowModal ] = useState({
        mainForm: false,
        contactForm: false,
        relationForm: false,
        sisForm: false,
    });

    const apiAgencyUserList =  async () => {
        const response = await getAgencyUserList(token, id)
        setAgencyUserList(response)
    };
    const apiAgencySite =  async () => {
        const response = await getAgencySiteInfos(token, id)
        setAgencySite(response)
    };

    const apiAgencyMain =  async () => {
        const response = await getAgencyMainInfos(token, id)
        setAgencyMainInfos(response)
    };

    const apiAgencyRelations =  async () => {
        const response = await getAgencyRelationInfos(token, id)
        setAgencyRelation(response)
    };

     const apiAgencyContactInfos =  async () => {
        const response = await getAgencyContactInfos(token, id)
        setAgencyContact(response)
    };

     const apiAgencyProContactInfos =  async () => {
        const response = await getAgencyContactProInfos(token, agencyProId)
        setAgencyContact(response)
     }

    const apiBillingInfos =  async () => {
        const response = await getAgencyBillingInfos(token, id)
        setAgencyBilling(response)
    };

    const apiNetworkList =  async () => {
        const response = await getNetworkList(token)
        setNetworkList(response)
    };

    const apiEnsembleList =  async () => {
        const response = await getEnsembleList(token)
        setEnsembleList(response)
    };

    const apiBillingAgencyList =  async () => {
        const response = await getBillingAgencyList(token)
        setBillingAgencyList(response)
    };

    const handleAgencyMainForm = (e) => {
        setShowModal({ ...showModal, mainForm: true })
    };

    const handleAgencyContactForm = (e) => {
        setShowModal({ ...showModal, contactForm: true })
    };

    const handleAgencyRelationForm = (e) => {
        setShowModal({ ...showModal, relationForm: true })
    };

    const handleSisForm = (e) => {
        setShowModal({ ...showModal, sisForm: true })
    };

    useEffect( () => {
        if (id != 0) {
            apiNetworkList()
            apiEnsembleList()
            apiBillingAgencyList()
            apiAgencyUserList()
            apiAgencyRelations()
            apiAgencyMain()
            apiAgencySite()
            apiBillingInfos()
            return () => {
            }
        }
   },[ id ]);

    useEffect(() => {
        if (countryList?.length === 0) {
            apiCountryList()
        }
    }, [ token ]);

    useEffect(() => {
            if(id != 0 && pathname?.includes('admin')) {
                apiAgencyContactInfos()
            } else if (!pathname?.includes('admin')) {
                apiAgencyProContactInfos()
            }
    }, [ id, pathname ]);


    const handleGenerateApi = async (apiPassword = "") => {
        const response = await newLoginOefApiRecord(agencyMainInfos?.userApi?.login_id ?? id, apiPassword);
        if (response != null) {
            if (response.status === "new") {
                document.getElementById('testConnect').classList.remove('disabled')
                document.getElementById('testConnect').innerHTML = "Utilisateur créé avec succès.";
            } else if (response.status === "update") {
                document.getElementById('testConnect').classList.remove('disabled')
                document.getElementById('testConnect').innerHTML = "Le mot de passe a bien été modifié.";
            }
        } else {
            document.getElementById('testConnect').innerHTML = "Une erreur est survenue";
        }
    }

    return (

        <main>
            { agencyMainInfos.error &&
                <Missing />
            }
            { !agencyMainInfos.error &&
                <>
                    <Header parent="Agences"
                            location={(id != 0)
                                ? "Modification d'une agence "
                                : "Ajout d'une agence "}
                            locationComp={`${agencyMainInfos?.name ? agencyMainInfos?.name : ""}`}
                            slug="/admin/agences"
                    />
                    {id != 0 &&
                        <nav className="tabs-menu">
                            <ul>
                                <li className={tab === "general" ? "active" : ""}><Link to={`/admin/agences/${id}/voir`}>Informations Agence</Link></li>
                                <li className={tab === "users" ? "active" : ""}><Link to={`/admin/agences/${id}/utilisateurs/voir`}>Comptes utilisateurs</Link></li>
                                <li className={tab === "billing" ? "active" : ""}><Link to={`/admin/agences/${id}/facturation/voir`}>Facturation</Link></li>
                            </ul>
                        </nav>
                    }
                    {tab === "general" && !agencyMainInfos.error && id != 0 &&
                        <>
                            {showModal.mainForm &&
                                <div className="modal main-infos">
                                    <FormAgencyGeneral apiAgencyMainInfos={apiAgencyMain} setShowModal={setShowModal} legend="Informations générales"/>
                                </div>
                            }
                            {showModal.contactForm &&
                                <div className="modal contact">
                                    <FormAgencyContacts agencyContactInfos={agencyContact}
                                                        apiAgencyProContacts={apiAgencyContactInfos}
                                                        apiAgencyContacts={apiAgencyContactInfos}
                                                        setShowModal={setShowModal}
                                                        legend="Contacts - Codes postaux"/>
                                </div>
                            }
                            {showModal.relationForm &&
                                <div className="modal relations">
                                    <div className="relation-modal">
                                        <FormAgencyRelation apiAgencyRelations={apiAgencyRelations}
                                                            setShowModal={setShowModal}
                                                            legend="Relations de l'agence"/>
                                    </div>
                                </div>
                            }
                            {showModal.sisForm &&
                                <div className="modal sis">
                                    <FormAgencySis setShowModal={setShowModal}
                                                   legend="Informations Site Internet"/>
                                </div>
                            }
                                <div className="tabs-menu agency-links">
                                    <a href={`${process.env.REACT_APP_OEF_URL}/${agencyMainInfos?.urlPreview}`}
                                       rel="noreferrer" target="_blank">Aperçu</a>
                                    <a href={agencyMainInfos?.urlDeceased?.startsWith("http")
                                        ? agencyMainInfos.urlDeceased
                                        : `${process.env.REACT_APP_OEF_URL}/${agencyMainInfos?.urlDeceased}`}
                                       rel="noreferrer" target="_blank">Liste des défunts</a>
                                    {agencySite?.storeUrl != null &&
                                        <a href={agencyMainInfos?.storeUrl} rel="noreferrer" target="_blank">Accès
                                            boutique</a>
                                    }
                                </div>
                                <div className="flex double-fieldset">
                                    <fieldset>
                                        <Icon span="Informations générales" source="fa fa-home"/>
                                        <div className="form-input">
                                            <label>Nom</label>
                                            <span>{agencyMainInfos?.name}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Siège social</label>
                                            <span>{agencyMainInfos?.headquarters === true ? "Oui" : "Non"}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Est un ensemble</label>
                                            <span>{agencyMainInfos?.isEnsemble == true ? "Oui" : "Non"}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Orias</label>
                                            <span>{agencyMainInfos?.orias}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Forme juridique</label>
                                            <span>{agencyMainInfos?.legalForm?.name}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Code d'habilitation</label>
                                            <span>{agencyMainInfos?.authorizationCode}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Date d'immatriculation</label>
                                            <span>{agencyMainInfos?.registrationDate}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Siret</label>
                                            <span>{agencyMainInfos?.siret}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>TVA intracommunautaire</label>
                                            <span>{agencyMainInfos?.tvaNumber}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Capital</label>
                                            <span>{agencyMainInfos?.capital}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Effectif</label>
                                            <span>{agencyMainInfos?.workforce}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Horaires</label>
                                            <span>{agencyMainInfos?.hours}</span>
                                        </div>
                                        <div className="form-input">
                                            <label id="activities-label">Activités</label>
                                            <div className="agency-activity">
                                                {agencyMainInfos?.activity && agencyMainInfos?.activity.map(
                                                    (activity => (
                                                        <p key={activity?.id}>{activity?.name}</p>
                                                    ))
                                                )}
                                            </div>
                                        </div>
                                        <div className="buttons-container">
                                            <button  className="red-button" onClick={handleAgencyMainForm}><i className="fa fa-pen-to-square"/><span>Modifier les informations</span></button>
                                        </div>
                                    </fieldset>
                                    <fieldset>
                                        <Icon span="Informations de contact" source="fa fa-envelope"/>
                                        <div className="form-input">
                                            <label>Adresse postale</label>
                                            <span>{agencyContact?.address?.address}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Complément d'adresse</label>
                                            <span>{agencyContact?.address?.addressComp}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Code postal</label>
                                            <span>{agencyContact?.address?.zipcode}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Ville</label>
                                            <span>{agencyContact?.address?.city}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Pays</label>
                                            <span>{selectedCountry}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Codes postaux additionnels</label>
                                            <TiptapView content={agencyContact?.zipcodes}></TiptapView>
                                        </div>
                                        <div className="form-input">
                                            <label>Latitude</label>
                                            <span>{agencyContact?.address?.latitude}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Longitude</label>
                                            <span>{agencyContact?.address?.longitude}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Téléphone</label>
                                            <span>{agencyContact?.phone}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Téléphone mobile</label>
                                            <span>{agencyContact?.mobile}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Email</label>
                                            <span>{agencyContact?.email}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Site Internet</label>
                                            <span>{agencyContact?.website}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>A une adresse pour les condoléances ?</label>
                                            <span>{agencyContact?.hasCondolenceEmail == true ? "Oui" : "Non"}</span>
                                        </div>
                                        {
                                            agencyContact?.hasCondolenceEmail == true &&
                                            <div className="form-input">
                                                <label>Adresse pour les condoléances</label>
                                                <span>{agencyContact?.condolenceEmail}</span>
                                            </div>
                                        }
                                        <div className="buttons-container">
                                            <button className="red-button" onClick={handleAgencyContactForm}><i className="fa fa-pen-to-square"/><span>Modifier les informations</span></button>
                                        </div>
                                    </fieldset>
                                </div>
                                <div className="flex double-fieldset">
                                    <fieldset className="api-password">
                                        <Icon span="Accès API" source="fa fa-database"/>
                                            { agencyMainInfos?.userApi != null ?
                                                <>
                                                    <p className="api-message">Un compte API est disponible pour cette agence. Voulez-vous générer un nouveau mot de passe ?</p>
                                                    <div className="buttons-container">
                                                        <button onClick={() =>setNewPassword(true)} className="green-button"><i className="fa fa-arrows-rotate"/><span>Générer</span></button>
                                                    </div>
                                                    { newPassword &&
                                                        <>
                                                            <div className="form-input">
                                                                <input type="password" id="pwdTest" onChange={(e) => setApiPassword(e.target.value)} />
                                                                <div className="buttons-container">
                                                                    <button onClick={() => handleGenerateApi(apiPassword)} className="green-button"><i className="fa fa-check"/><span>Créer l'accès</span></button>
                                                                </div>
                                                            </div>
                                                            <span id="testConnect" className="api-test-message disabled"></span>
                                                        </>
                                                    }
                                                </>
                                                :
                                                <>
                                                    <div className="form-input">
                                                        <label>Générer un nouveau mot de passe pour l'API ?</label>
                                                        <button onClick={() => handleGenerateApi()} className="api green-button"><i className="fa fa-arrows-rotate"/><span>Générer</span></button>
                                                    </div>
                                                    <span id="testConnect" className="api-test-message disabled"></span>
                                                </>
                                            }
                                    </fieldset>
                                    <fieldset>
                                        {(agencyMainInfos?.isEnsemble != true) &&
                                            <div className="form-input">
                                                <label>Ensemble de l'agence</label>
                                                <span>{agencyRelation?.ensemble?.name ? `${agencyRelation?.ensemble?.name} (ID : ${agencyRelation?.ensemble?.id})` : "Pas d'ensemble"}</span>
                                            </div>
                                        }
                                        <Icon span="Relations de l'agence" source="fa fa-users"/>
                                        <div className="form-input">
                                            <label>Réseau de l'agence</label>
                                            <span>{agencyRelation?.network?.name ? `${agencyRelation?.network?.name} (ID : ${agencyRelation?.network?.id})` : "Pas de réseau"}</span>
                                        </div>
                                        <div className="buttons-container">
                                            <button className="red-button" onClick={handleAgencyRelationForm}><i className="fa fa-pen-to-square"/><span>Modifier les relations</span></button>
                                        </div>
                                    </fieldset>
                                </div>

                                <div>
                                    <fieldset>
                                        <Icon span="Informations du site internet" source="fa fa-display"/>
                                        <div className="form-input">
                                            <label>Solution Multi Services</label>
                                            <span>{agencySite?.sms}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Site activé</label>
                                            <span>{agencySite?.siteEnabled === true ? "Oui" : "Non"}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>URL Site Internet Oef<br/>(doit être unique)</label>
                                            <span>{agencySite?.url}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>URL Site Internet <br/>Partenaire</label>
                                            <span>{agencySite?.template}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Couleur principale</label>
                                            <input type="color" disabled="disabled"
                                                   value={agencySite?.mainColor}/>
                                        </div>
                                        <div className="form-input">
                                            <label>Couleur secondaire</label>
                                            <input type="color" disabled="disabled"
                                                   value={agencySite?.mainColor2}/>
                                        </div>
                                        <div className="form-input agency-picture">
                                            <label>Image du site</label>
                                            {agencySite?.agencypicture ? (
                                                <span><img
                                                    src={`${imageBaseUrl}/media/agency_pictures/${agencySite.agencypicture}`}
                                                    alt="Photo de présentation de l'agence"
                                                /></span>
                                            ) : (
                                                <span>Pas d'image</span>
                                            )}
                                        </div>
                                        <div className="form-input logo">
                                            <label>Logo de l'agence</label>
                                            {agencySite?.logo ? (
                                                <span><img
                                                    src={`${imageBaseUrl}/media/logos/${agencySite.logo}`}
                                                    alt="Logo de l'agence"
                                                /></span>
                                            ) : (
                                                <span>Pas de logo</span>
                                            )}
                                        </div>
                                        <div className="form-input">
                                            <label>Email du site</label>
                                            <span>{agencySite?.siteEmail}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Offrir des fleurs</label>
                                            <span>{agencySite?.sendFlowers == 1 ? "Oui" : "Non"}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Condoléance par défaut</label>
                                            <span>{agencySite?.defaultCondolence == 1 ? "Oui" : "Non"}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Identifiant Lomaco</label>
                                            <span>{agencySite?.lomacoId}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Login Lomaco</label>
                                            <span>{agencySite?.lomacoLogin}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Mot de passe Lomaco</label>
                                            <span defaultValue={agencySite?.lomacoPwd}/>
                                        </div>
                                        <div className="form-input">
                                            <label>URL de la boutique</label>
                                            <span>{agencySite?.storeUrl}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>L'agitateur floral</label>
                                            <span>{agencySite?.storeUrl}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>L'entreprise de Pompes Funèbres autorise la livraison : </label>
                                            <span>{agencySite?.storeUrl}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>Boutique ouverte le week-end</label>
                                            <span>{agencySite?.shopWeekend == 1 ? "Oui" : "Non"}</span>
                                        </div>
                                        <div className="form-input">
                                            <label>CSS du logo</label>
                                            <textarea disabled="disabled"
                                                      defaultValue={agencySite?.logoCss}></textarea>
                                        </div>
                                        <div className="form-input fulltext">
                                            <label>Texte page "Bienvenue chez nous"</label>
                                            <TiptapView content={agencySite?.welcomeText}/>
                                        </div>
                                        <div className="form-input">
                                            <label>Texte de présentation</label>
                                            <TiptapView content={agencySite?.previewtext}/>
                                        </div>
                                        <div className="form-input fulltext">
                                            <label>Texte complet</label>
                                            <TiptapView content={agencySite?.fullText}></TiptapView>
                                        </div>
                                        <div className="form-input shopSchedule">
                                            <label>Magasin</label>
                                            <textarea disabled="disabled"
                                                      defaultValue={agencySite?.shopText}></textarea>
                                        </div>
                                        <div className="form-input funerariumSchedule">
                                            <label>Funérarium</label>
                                            <textarea disabled="disabled"
                                                      defaultValue={agencySite?.funerariumText}></textarea>
                                        </div>
                                        <div className="form-input marbSchedule">
                                            <label>Marbrerie</label>
                                            <textarea disabled="disabled"
                                                      defaultValue={agencySite?.marbleText}></textarea>
                                        </div>
                                        <div className="form-input team">
                                            <label>Notre équipe</label>
                                            <textarea disabled="disabled"
                                                      defaultValue={agencySite?.teamText}></textarea>
                                        </div>
                                        <div className="buttons-container">
                                            <button onClick={() => navigate(-1)}><i className="fa fa-arrow-left"/><span>Retour</span></button>
                                            <button onClick={handleSisForm} className="red-button"><i className="fa fa-pen-to-square"/><span>Modifier les informations</span></button>

                                        </div>
                                    </fieldset>
                                </div>
                        </>
                    }
                    {tab === "general" && id == 0 &&
                        <section className="agency-search-section">
                            <FormAgencyCreate legend="Création d'une agence"/>
                        </section>
                    }
                    {tab === "users" && !agencyUserList?.error &&
                        <div className="content-container">
                            <Icon span="Liste des utilisateurs"></Icon>
                            <div className="dashboard">
                                <Dashboard location="Agence - Utilisateurs" dataObject={agencyUserList || []} order={agencyUsersOrder}/>
                            </div>
                        </div>
                    }
                    {tab === "billing" && !agencyBilling.error &&
                        <div className="flex">
                            <ViewAgencyBilling/>
                        </div>
                    }
                </>
            }
        </main>
    )
}